import React from "react";
import BatteryPercentageStatus from "../../../Battery/phase3/BatteryPercentageStatus";

const BatteryList = ({ batteries, selectedBatteries, onBatterySelect }) => {
  return batteries.map((battery) => {
    const selected = selectedBatteries.includes(battery.id);

    return (
      <div
        key={battery.id}
        onClick={() => onBatterySelect(battery.id)}
        className={`
          h-[44px]
          flex
          items-center
          justify-between
          px-4
          border-b
          border-light-grey
          cursor-pointer
          transition-all
          ${selected ? "bg-[#D8E5E5]" : "bg-white"}
        `}
      >
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            checked={selected}
            readOnly
            className="w-4 h-4 cursor-pointer rounded-md border border-light-grey accent-[#0A6870]"
          />

          <p className="font-aileron font-semibold text-xs text-black">
            {battery.registrationNo || battery.id}
          </p>
        </div>

        <div className="flex items-center gap-12">
          <div className="h-6.5 min-w-[32px] px-2 py-1 rounded bg-[#E6EDEE] flex items-center justify-center">
            <p className="font-poppins font-medium text-xs leading-none text-[#085054]">
              {battery.slot}
            </p>
          </div>

          <div className="w-[42px] text-right">
            <BatteryPercentageStatus
              type="battery-list"
              detail={{ percentage: battery.percentage }}
            />
          </div>
        </div>
      </div>
    );
  });
};

export default BatteryList;
